import React from "react";
import { Toaster as HotToaster } from "react-hot-toast";
const Toaster = () => {
  return (
    <HotToaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        duration: 3000,
        style: {
          borderRadius: "8px",
          background: "#333",
          color: "#fff",
        },
      }}
    />
  );
};

export default Toaster;
